import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import translations from '@/translations';
// 自定义渲染（隐藏了 label 标签）
import CustomRenderer from '@/modules/custom-renderer';
// 自定义元素选中时的弹出菜单（修改 默认任务 为 用户任务）
import CustomContentPadProvider from '../../../../../package/designer/plugins/content-pad';
// 自定义左侧菜单（修改 默认任务 为 用户任务）
import CustomPaletteProvider from '../../../../../package/designer/plugins/palette';
import Log from '../../../../../package/Log';
// // 任务resize
// import resizeTask from "bpmn-js-task-resize/lib";
// // bpmn theme plugin
// import sketchyRendererModule from "bpmn-js-sketchy";
// 小地图
import minimapModule from 'diagram-js-minimap';
import UserSql from '../../../../modules/extension/user.json';

// clickoutside
import clickoutside from 'element-ui/lib/utils/clickoutside';
import { getUser, getPositionList } from '@/services/system';
export default {
  name: 'flowDesign',
  directives: {
    clickoutside: clickoutside
  },
  props: {
    xmlStr: String,
    formFieldArr: Array,
    processName: String,
    jsonData: Object
  },
  watch: {
    xmlStr: {
      immediate: true,
      handler: function handler(val) {
        var _this = this;
        this.xmlString = val;
        // setTimeout(() => {
        this.$nextTick(function () {
          _this.$refs.processDesigner.createNewDiagram(_this.xmlString);
        });

        // }, 2000);
      }
    }
  },
  data: function data() {
    return {
      // xmlString: "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<bpmn2:definitions xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xmlns:bpmn2=\"http://www.omg.org/spec/BPMN/20100524/MODEL\" xmlns:bpmndi=\"http://www.omg.org/spec/BPMN/20100524/DI\" xmlns:dc=\"http://www.omg.org/spec/DD/20100524/DC\" xmlns:di=\"http://www.omg.org/spec/DD/20100524/DI\" xmlns:flowable=\"http://flowable.org/bpmn\" id=\"diagram_Process_1655635767924\" targetNamespace=\"http://flowable.org/bpmn\">\n  <bpmn2:process id=\"Process_1655635767924\" name=\"业务流程_1655635767924\" isExecutable=\"true\">\n    <bpmn2:startEvent id=\"Event_0qmiy28\">\n      <bpmn2:extensionElements>\n        <flowable:formData />\n      </bpmn2:extensionElements>\n      <bpmn2:outgoing>Flow_1uzh1vw</bpmn2:outgoing>\n    </bpmn2:startEvent>\n    <bpmn2:userTask id=\"Activity_1c15eb1\" name=\"申请人\">\n      <bpmn2:incoming>Flow_1uzh1vw</bpmn2:incoming>\n      <bpmn2:outgoing>Flow_19yo7nv</bpmn2:outgoing>\n    </bpmn2:userTask>\n    <bpmn2:sequenceFlow id=\"Flow_1uzh1vw\" sourceRef=\"Event_0qmiy28\" targetRef=\"Activity_1c15eb1\" />\n    <bpmn2:userTask id=\"Activity_1f8teln\" name=\"审批人\" flowable:assignee=\"210008\">\n      <bpmn2:incoming>Flow_19yo7nv</bpmn2:incoming>\n      <bpmn2:outgoing>Flow_1t4hzmw</bpmn2:outgoing>\n    </bpmn2:userTask>\n    <bpmn2:sequenceFlow id=\"Flow_19yo7nv\" sourceRef=\"Activity_1c15eb1\" targetRef=\"Activity_1f8teln\" />\n    <bpmn2:endEvent id=\"Event_1bu9lcz\">\n      <bpmn2:incoming>Flow_1t4hzmw</bpmn2:incoming>\n    </bpmn2:endEvent>\n    <bpmn2:sequenceFlow id=\"Flow_1t4hzmw\" sourceRef=\"Activity_1f8teln\" targetRef=\"Event_1bu9lcz\" />\n  </bpmn2:process>\n  <bpmndi:BPMNDiagram id=\"BPMNDiagram_1\">\n    <bpmndi:BPMNPlane id=\"BPMNPlane_1\" bpmnElement=\"Process_1655635767924\">\n      <bpmndi:BPMNEdge id=\"Flow_1uzh1vw_di\" bpmnElement=\"Flow_1uzh1vw\">\n        <di:waypoint x=\"308\" y=\"220\" />\n        <di:waypoint x=\"360\" y=\"220\" />\n      </bpmndi:BPMNEdge>\n      <bpmndi:BPMNEdge id=\"Flow_19yo7nv_di\" bpmnElement=\"Flow_19yo7nv\">\n        <di:waypoint x=\"460\" y=\"220\" />\n        <di:waypoint x=\"520\" y=\"220\" />\n      </bpmndi:BPMNEdge>\n      <bpmndi:BPMNEdge id=\"Flow_1t4hzmw_di\" bpmnElement=\"Flow_1t4hzmw\">\n        <di:waypoint x=\"620\" y=\"220\" />\n        <di:waypoint x=\"682\" y=\"220\" />\n      </bpmndi:BPMNEdge>\n      <bpmndi:BPMNShape id=\"Event_0qmiy28_di\" bpmnElement=\"Event_0qmiy28\">\n        <dc:Bounds x=\"272\" y=\"202\" width=\"36\" height=\"36\" />\n      </bpmndi:BPMNShape>\n      <bpmndi:BPMNShape id=\"Activity_1c15eb1_di\" bpmnElement=\"Activity_1c15eb1\">\n        <dc:Bounds x=\"360\" y=\"180\" width=\"100\" height=\"80\" />\n      </bpmndi:BPMNShape>\n      <bpmndi:BPMNShape id=\"Activity_1f8teln_di\" bpmnElement=\"Activity_1f8teln\">\n        <dc:Bounds x=\"520\" y=\"180\" width=\"100\" height=\"80\" />\n      </bpmndi:BPMNShape>\n      <bpmndi:BPMNShape id=\"Event_1bu9lcz_di\" bpmnElement=\"Event_1bu9lcz\">\n        <dc:Bounds x=\"682\" y=\"202\" width=\"36\" height=\"36\" />\n      </bpmndi:BPMNShape>\n    </bpmndi:BPMNPlane>\n  </bpmndi:BPMNDiagram>\n</bpmn2:definitions>\n",
      xmlString: '',
      modeler: null,
      reloadIndex: 0,
      controlDrawerVisible: false,
      infoTipVisible: false,
      pageMode: false,
      translationsSelf: translations,
      controlForm: {
        processId: '',
        processName: '',
        simulation: true,
        labelEditing: false,
        labelVisible: false,
        prefix: 'flowable',
        headerButtonSize: 'mini',
        events: ['element.click', 'element.contextmenu'],
        // additionalModel: []
        moddleExtension: {
          user: UserSql
        },
        additionalModel: [CustomContentPadProvider, CustomPaletteProvider, minimapModule, CustomRenderer]
      },
      addis: {
        CustomContentPadProvider: CustomContentPadProvider,
        CustomPaletteProvider: CustomPaletteProvider
      },
      userList: [{
        userId: '${INITIATOR}',
        userName: '流程创建人'
      }, {
        userId: 1,
        userName: 'admin',
        passWord: 'VGGBx3kRlpHyAxvpqGqCgg==',
        sex: 'Sex001',
        birthDate: 946656000000,
        idCard: '130133199003046833',
        departId: 10001,
        departName: null,
        partId: 20002,
        partName: null,
        labourId: 50002,
        labourName: null,
        areaId: 0,
        areaName: null,
        mobile: '13111111111',
        entryDate: 946656000000,
        termDate: 946656000000,
        commStartDate: 946656000000,
        commEndDate: 946656000000,
        workStatus: 0,
        status: 1
      }, {
        userId: 2,
        userName: '感到十分',
        passWord: 'VGGBx3kRlpHyAxvpqGqCgg==',
        sex: 'Sex001',
        birthDate: 946656000000,
        idCard: '140123198303125554',
        departId: 10001,
        departName: null,
        partId: 20002,
        partName: null,
        labourId: 50002,
        labourName: null,
        areaId: 0,
        areaName: null,
        mobile: '13555555555',
        entryDate: 946656000000,
        termDate: 946656000000,
        commStartDate: 946656000000,
        commEndDate: 946656000000,
        workStatus: 0,
        status: 1
      }, {
        userId: 210007,
        userName: '付正扬',
        passWord: 'VGGBx3kRlpHyAxvpqGqCgg==',
        sex: 'Sex001',
        birthDate: null,
        idCard: '510181199609146435',
        departId: null,
        departName: null,
        partId: null,
        partName: null,
        labourId: null,
        labourName: null,
        areaId: null,
        areaName: null,
        mobile: '13540498350',
        entryDate: null,
        termDate: null,
        commStartDate: null,
        commEndDate: null,
        workStatus: null,
        status: 1
      }, {
        userId: 210008,
        userName: '赛文',
        passWord: 'VGGBx3kRlpHyAxvpqGqCgg==',
        sex: null,
        birthDate: null,
        idCard: '510181199707077777',
        departId: null,
        departName: null,
        partId: null,
        partName: null,
        labourId: null,
        labourName: null,
        areaId: null,
        areaName: null,
        mobile: '13777777777',
        entryDate: null,
        termDate: null,
        commStartDate: null,
        commEndDate: null,
        workStatus: null,
        status: 1
      }, {
        userId: 210009,
        userName: '迪迦',
        passWord: 'VGGBx3kRlpHyAxvpqGqCgg==',
        sex: null,
        birthDate: null,
        idCard: '510181199909090909',
        departId: null,
        departName: null,
        partId: null,
        partName: null,
        labourId: null,
        labourName: null,
        areaId: null,
        areaName: null,
        mobile: '13999999999',
        entryDate: null,
        termDate: null,
        commStartDate: null,
        commEndDate: null,
        workStatus: null,
        status: 1
      }, {
        userId: 210010,
        userName: '戴拿',
        passWord: 'VGGBx3kRlpHyAxvpqGqCgg==',
        sex: null,
        birthDate: null,
        idCard: '510181199101010101',
        departId: null,
        departName: null,
        partId: null,
        partName: null,
        labourId: null,
        labourName: null,
        areaId: null,
        areaName: null,
        mobile: '13888888888',
        entryDate: null,
        termDate: null,
        commStartDate: null,
        commEndDate: null,
        workStatus: null,
        status: 1
      }, {
        userId: 210011,
        userName: '盖亚',
        passWord: 'VGGBx3kRlpHyAxvpqGqCgg==',
        sex: null,
        birthDate: null,
        idCard: '510181199010101011',
        departId: null,
        departName: null,
        partId: null,
        partName: null,
        labourId: null,
        labourName: null,
        areaId: null,
        areaName: null,
        mobile: '13444444444',
        entryDate: null,
        termDate: null,
        commStartDate: null,
        commEndDate: null,
        workStatus: null,
        status: 1
      }, {
        userId: 210012,
        userName: '泰罗',
        passWord: 'VGGBx3kRlpHyAxvpqGqCgg==',
        sex: null,
        birthDate: null,
        idCard: '510181199303030303',
        departId: null,
        departName: null,
        partId: null,
        partName: null,
        labourId: null,
        labourName: null,
        areaId: null,
        areaName: null,
        mobile: '13333333333',
        entryDate: null,
        termDate: null,
        commStartDate: null,
        commEndDate: null,
        workStatus: null,
        status: 1
      }, {
        userId: 210013,
        userName: '艾斯',
        passWord: 'VGGBx3kRlpHyAxvpqGqCgg==',
        sex: null,
        birthDate: null,
        idCard: '510181199202020202',
        departId: null,
        departName: null,
        partId: null,
        partName: null,
        labourId: null,
        labourName: null,
        areaId: null,
        areaName: null,
        mobile: '13222222222',
        entryDate: null,
        termDate: null,
        commStartDate: null,
        commEndDate: null,
        workStatus: null,
        status: 1
      }, {
        userId: 210014,
        userName: '杰克',
        passWord: 'VGGBx3kRlpHyAxvpqGqCgg==',
        sex: null,
        birthDate: null,
        idCard: '510181199303030303',
        departId: null,
        departName: null,
        partId: null,
        partName: null,
        labourId: null,
        labourName: null,
        areaId: null,
        areaName: null,
        mobile: '13666666666',
        entryDate: null,
        termDate: null,
        commStartDate: null,
        commEndDate: null,
        workStatus: null,
        status: 1
      }],
      postList: []
    };
  },
  created: function created() {
    this.queryUsers();
  },
  methods: {
    initModeler: function initModeler(modeler) {
      var _this2 = this;
      setTimeout(function () {
        _this2.modeler = modeler;
        var canvas = modeler.get('canvas');
        var rootElement = canvas.getRootElement();
        Log.prettyPrimary('Process Id:', rootElement.id);
        Log.prettyPrimary('Process Name:', rootElement.businessObject.name);
        _this2.controlForm.processId = rootElement.id;
        _this2.controlForm.processName = rootElement.businessObject.name;
      }, 10);
    },
    reloadProcessDesigner: function reloadProcessDesigner(notDeep) {
      this.controlForm.additionalModel = [];
      for (var key in this.addis) {
        if (this.addis[key]) {
          this.controlForm.additionalModel.push(this.addis[key]);
        }
      }
      !notDeep && (this.xmlString = undefined);
      this.reloadIndex += 1;
      this.modeler = null; // 避免 panel 异常
    },
    changeLabelEditingStatus: function changeLabelEditingStatus(status) {
      this.addis.labelEditing = status ? {
        labelEditingProvider: ['value', '']
      } : false;
      this.reloadProcessDesigner();
    },
    changeLabelVisibleStatus: function changeLabelVisibleStatus(status) {
      this.addis.customRenderer = status ? CustomRenderer : false;
      this.reloadProcessDesigner();
    },
    elementClick: function elementClick(element) {
      this.element = element;
    },
    elementContextmenu: function elementContextmenu(element) {},
    changePageMode: function changePageMode(mode) {
      var theme = mode ? {
        // dark
        stroke: '#ffffff',
        fill: '#333333'
      } : {
        // light
        stroke: '#000000',
        fill: '#ffffff'
      };
      var elements = this.modeler.get('elementRegistry').getAll();
      this.modeler.get('modeling').setColor(elements, theme);
    },
    queryUsers: function queryUsers() {
      var _this3 = this;
      getUser().then(function (res) {
        if (res.data.code == 200) {
          res.data.data.unshift({
            userId: '${INITIATOR}',
            userName: '流程创建人'
          });
          _this3.userList = res.data.data;
        }
      });
    },
    queryPosts: function queryPosts() {
      getPositionList('', 1).then(function (res) {});
    }
  }
};